import Api from "../Api"



const getAll = async (search, filtros) => {

    try {


        let urlParams = []
        if (search != undefined && search != null) {
            urlParams.push('search=' + search)
        }



        if (filtros?.tiposServicosId) {
            urlParams.push('tiposServicosId=' + filtros?.tiposServicosId)
        }
        if (filtros?.page) {
            urlParams.push('page=' + filtros?.page)
        }
         if (filtros?.paginate) {
            urlParams.push('paginate=' + filtros?.paginate)
        }

        urlParams = urlParams.join('&')
        const { data } = await Api.get('/profissionais?' + urlParams)
        if (data) {
            return data;
        }
    } catch (error) {
        console.log(error)
    }



}
const getById = async (idProfissional) => {

    try {
        const { data } = await Api.get('/profissionais/' + idProfissional)
        if (data) {
            return data;
        }
    } catch (error) {
        console.log(error)
    }

}
const store = async (dataForm) => {


    try {
        const { data } = await Api.post('/profissionais', dataForm)

        console.log(data)
        return data
    } catch (error) {
        console.log(error)
        return error
    }

}
const updateById = async (idProfissional, dataForm) => {
    try {
        const { data } = await Api.put('/profissionais/' + idProfissional, dataForm)
        return data;
    } catch (error) {
        console.log(error)
        return error
    }


}
const deleteById = async (idProfissional) => {

    try {
        const { data } = await Api.delete('/profissionais/' + idProfissional)
        return data;
    } catch (error) {
        console.log(error)
        return error
    }

}

export const ProfissionaisService = {
    store,
    getAll,
    getById,
    updateById,
    deleteById
}